import LazyLoadImages from "./events/ImageLoaded";

import StarterKit from "./StarterKit";

import Appearance from "./components/Appearance";
import Search from "./components/Search";
import SliderCards from "./components/SliderCards";
import BlockCollapse from "./blocks/BlockCollapse";
import LayoutOffset from "./components/LayoutOffset";
import Typewriter from "./components/Typewriter";
import FilterSelect from "./components/FilterSelect";
import BannerSlider from "./components/BannerSlider";
import BlockListingProject from "./blocks/BlockListingProject";
import BlockPlaylistVideo from "./blocks/BlockPlaylistVideo";
import BlockSliderMultiple from "./blocks/BlockSliderMultiple";
import BlockTimeline from "./blocks/BlockTimeline";


// First of the first
new LazyLoadImages();

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	new StarterKit();

    new Appearance();
    new BannerSlider();
    new FilterSelect();
    new LayoutOffset();
    new Search();
    new SliderCards();
    new Typewriter();

	// Blocks
	new BlockCollapse();
	new BlockListingProject();
    new BlockPlaylistVideo();
	new BlockSliderMultiple();
	new BlockTimeline();
});

// window.initMap = function () {
// 	window.dispatchEvent(new Event('googleMapApiLoaded'));
// };
